import { Actions } from '../actions/primaryOrganizationReleases';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IRelease } from '../interfaces/release';

export type State = DeepReadonly<{
  isFetching: boolean;
  primaryOrganizationReleases: IRelease[] | null;
  error: AxiosError | null;
}>;

export const initialState: State = {
  isFetching: false,
  primaryOrganizationReleases: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_PRIMARY_ORGANIZATION_RELEASES_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCH_PRIMARY_ORGANIZATION_RELEASES_SUCCESS':
      return {
        isFetching: false,
        primaryOrganizationReleases: action.payload,
        error: null
      };
    case 'FETCH_PRIMARY_ORGANIZATION_RELEASES_FAILURE':
      return {
        isFetching: false,
        primaryOrganizationReleases: null,
        error: action.error
      };
    default:
      return state;
  }
}
